import { render, staticRenderFns } from "./ViewPurchase.vue?vue&type=template&id=22a62369&scoped=true"
import script from "./ViewPurchase.vue?vue&type=script&lang=js"
export * from "./ViewPurchase.vue?vue&type=script&lang=js"
import style0 from "./ViewPurchase.vue?vue&type=style&index=0&id=22a62369&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a62369",
  null
  
)

export default component.exports